function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".EditUser_old-1{fill:#ffbe54;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "EditUser_old-1",
  d: "M5.2,7A2.4,2.4,0,1,0,2.8,4.6,2.39,2.39,0,0,0,5.2,7Zm1.68.6H6.57a3.28,3.28,0,0,1-2.74,0H3.52A2.52,2.52,0,0,0,1,10.12v.78a.9.9,0,0,0,.9.9H7.05a.9.9,0,0,1,0-.4l.12-1.14,0-.21L7.3,9.9,8.75,8.45A2.48,2.48,0,0,0,6.88,7.6Zm.85,2.72L7.6,11.47a.3.3,0,0,0,.33.33l1.14-.13,2.59-2.59L10.32,7.74Zm5.14-3.08-.71-.71a.47.47,0,0,0-.64,0l-.7.71-.08.08,1.35,1.34.78-.78a.47.47,0,0,0,0-.64Z",
  transform: "translate(-1 -2.2)"
});

var SvgEditUserLight = function SvgEditUserLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EditUser_old",
    "data-name": "Laag 1",
    viewBox: "0 0 12 9.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditUserLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EditUserLight.4106bfbf.svg";
export { ForwardRef as ReactComponent };